export default __webpack_public_path__ + "static/media/OrilliumIcon.839acc2e.png";